<template>
  <v-layout>
    <v-flex>
      <v-card>
        <v-img

          src="http://splitsistems.ru/files/uploads/404_error.png"
        >
          <v-container fill-height fluid>
            <v-layout align-start column>
              <v-flex align-start xm12>
                <div align="left">
                  <span class="grey--text  relative"><h1>Ошибка: 404 </h1></span><br>
                  <strong><span>К сожалению, такой страницы не существует. </span></strong><br>
                  <strong><span>Вероятно, она была удалена с сервера, </span></strong><br>
                  <strong><span>либо ее здесь никогда не было</span></strong>
                  <v-btn :to="{name: 'OpenDiss'}" block color="primary" dark>Вернуться на главную страницу</v-btn>
                </div>
              </v-flex>
            </v-layout>
          </v-container>
        </v-img>


      </v-card>
    </v-flex>
  </v-layout>

</template>

<script>
  export default {
    name: "PageNotFound"
  }
</script>

<style scoped>

</style>
